/* istanbul ignore file */
import useOpportunityService from 'domain/sales/opportunity/opportunityService';
import { useFormContext, LoadDropdown, DefaultDropdownProps } from 'framework/form';
import { get } from 'lodash';

interface RelatedDiscoveryOpportunityInputDropdownProps extends DefaultDropdownProps {
  accountAliasSource: string;
}

const RelatedDiscoveryOpportunityInputDropdown = ({
  accountAliasSource,
  ...props
}: RelatedDiscoveryOpportunityInputDropdownProps) => {
  const { data } = useFormContext();
  const { search } = useOpportunityService() as any;

  const accountId = get(data, accountAliasSource);
  const currentOppId = get(data, 'id', null);

  const searchValues = {
    accountId,
    currentOpportunityId: currentOppId,
  };

  const searchRequest = {
    filter: {
      'specification:availableDiscoveryOpportunitiesSpecification': {
        eq: searchValues,
      },
    },
  };

  const loadOpportunities = async () => {
    return search(searchRequest);
  };

  return (
    <LoadDropdown
      loadDataMethod={loadOpportunities}
      mapResults={opp => ({
        value: opp.id,
        label: opp.name,
      })}
      showLoader
      placeholder="Select Opportunity"
      deps={[accountId]}
      {...props}
    />
  );
};

export default RelatedDiscoveryOpportunityInputDropdown;
